import { render, staticRenderFns } from "./RouteIcon.vue?vue&type=template&id=f4a0cd38"
import script from "./RouteIcon.vue?vue&type=script&lang=js"
export * from "./RouteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports